// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3IAVN","addWidgetButton":"Header_addWidgetButton__2k-IC","dashboardTabs":"Header_dashboardTabs__1QM-_","active":"Header_active__gojtg"};